import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const agencyOption = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 10,
  width: '100%'
})

export const agencyOptionStatus = style({
  fontSize: vars.font.subcontent.size,
  color: vars.color.success
})
